export class FindAllBoards {
  public static readonly type = '[Project/Board/List] FindAllBoards';
}
